export const Telegram = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_41_1655)">
        <path
          d="M12 24c6.627 0 12-5.373 12-12S18.626 0 12 0C5.371 0 0 5.373 0 12s5.372 12 12 12z"
          fill="url(#prefix__paint0_linear_41_1655)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.431 11.873c3.498-1.524 5.831-2.529 6.998-3.014 3.333-1.386 4.025-1.627 4.476-1.635.1-.002.322.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.167.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212-.07-.063-.174-.041-.248-.024-.107.024-1.794 1.139-5.062 3.345-.48.33-.913.49-1.302.481-.428-.01-1.252-.242-1.865-.441-.751-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663z"
          fill="#fff"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__paint0_linear_41_1655"
          x1={11.999}
          y1={0}
          x2={11.999}
          y2={23.822}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2AABEE" />
          <stop offset={1} stopColor="#229ED9" />
        </linearGradient>
        <clipPath id="prefix__clip0_41_1655">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Whatsapp = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M0 24L1.687 17.837C0.646 16.033 0.099 13.988 0.1 11.891C0.103 5.335 5.438 0 11.993 0C15.174 0.001 18.16 1.24 20.406 3.488C22.651 5.736 23.887 8.724 23.886 11.902C23.883 18.459 18.548 23.794 11.993 23.794C10.003 23.793 8.042 23.294 6.305 22.346L0 24ZM6.597 20.193C8.273 21.188 9.873 21.784 11.989 21.785C17.437 21.785 21.875 17.351 21.878 11.9C21.88 6.438 17.463 2.01 11.997 2.008C6.545 2.008 2.11 6.442 2.108 11.892C2.107 14.117 2.759 15.783 3.854 17.526L2.855 21.174L6.597 20.193ZM17.984 14.729C17.91 14.605 17.712 14.531 17.414 14.382C17.117 14.233 15.656 13.514 15.383 13.415C15.111 13.316 14.913 13.266 14.714 13.564C14.516 13.861 13.946 14.531 13.773 14.729C13.6 14.927 13.426 14.952 13.129 14.803C12.832 14.654 11.874 14.341 10.739 13.328C9.856 12.54 9.259 11.567 9.086 11.269C8.913 10.972 9.068 10.811 9.216 10.663C9.35 10.53 9.513 10.316 9.662 10.142C9.813 9.97 9.862 9.846 9.962 9.647C10.061 9.449 10.012 9.275 9.937 9.126C9.862 8.978 9.268 7.515 9.021 6.92C8.779 6.341 8.534 6.419 8.352 6.41L7.782 6.4C7.584 6.4 7.262 6.474 6.99 6.772C6.718 7.07 5.95 7.788 5.95 9.251C5.95 10.714 7.015 12.127 7.163 12.325C7.312 12.523 9.258 15.525 12.239 16.812C12.948 17.118 13.502 17.301 13.933 17.438C14.645 17.664 15.293 17.632 15.805 17.556C16.376 17.471 17.563 16.837 17.811 16.143C18.059 15.448 18.059 14.853 17.984 14.729Z"
        fill="#25D366"
      />
    </svg>
  );
};

export const Youtube = (props) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <g clip-path="url(#clip0_41_1669)">
        <path
          d="M23.522 6.18541C23.3863 5.67482 23.1189 5.20883 22.7465 4.83407C22.3741 4.4593 21.9099 4.18891 21.4002 4.04996C19.5238 3.54541 12.0238 3.54541 12.0238 3.54541C12.0238 3.54541 4.5238 3.54541 2.64744 4.04996C2.13773 4.18891 1.67346 4.4593 1.30109 4.83407C0.92872 5.20883 0.661309 5.67482 0.525622 6.18541C0.0238038 8.06996 0.0238037 12 0.0238037 12C0.0238037 12 0.0238038 15.93 0.525622 17.8145C0.661309 18.3251 0.92872 18.7911 1.30109 19.1658C1.67346 19.5406 2.13773 19.811 2.64744 19.95C4.5238 20.4545 12.0238 20.4545 12.0238 20.4545C12.0238 20.4545 19.5238 20.4545 21.4002 19.95C21.9099 19.811 22.3741 19.5406 22.7465 19.1658C23.1189 18.7911 23.3863 18.3251 23.522 17.8145C24.0238 15.93 24.0238 12 24.0238 12C24.0238 12 24.0238 8.06996 23.522 6.18541Z"
          fill="#FF0302"
        />
        <path
          d="M9.56934 15.5687V8.4314L15.8421 12L9.56934 15.5687Z"
          fill="#FEFEFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_41_1669">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
